import { axInst } from "../../../Components/Login/Service";

export const complaint_kpi = async (body) => {
  try {
    const res = await axInst.post("complaints/complaints-cards", body);
    return {
      ttlComplaint: res.data.total_open_complaint,
      ttlRegistered: res.data.total_complaints_registered_today,
      ttlResolved: res.data.today_resolved,
      ttlMtd: res.data.mtd_registered,
      ttlMcr: res.data.mtd_resolved,
      esclated_complaint: res.data.escalation_complaint_count,
    };
  } catch (error) {
    console.error(error);
  }
};
